import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { MUTUAL_FUNDS_DIVIDEND_ACCRUAL_BASE_PATH } from '../../../../../../../../../features/mutual-funds/dividend-accrual/dividend-accrual-routing';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual',
)({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'mutual-funds-dividend-accrual-list',
        label: 'Mutual Funds',
        to: MUTUAL_FUNDS_DIVIDEND_ACCRUAL_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
